import { APIHelper } from '@archistarai/auth-frontend';
import Vue from 'vue';

export default {
  state: {
    locations: []
  },
  getters: {
    get: (state) => (id) => {
      return state.locations.find((l) => (l.guid = id));
    },
    whereCompanyGuid: (state) => (guid) => {
      return state.locations.filter((l) => l.companyGuid === guid);
    }
  },
  mutations: {
    ADD_LOCATIONS(state, locations) {
      locations.forEach((location) => {
        let index = locations.findIndex((l) => l.guid === locations.guid);
        if (index < 0) {
          state.locations.push(location);
        } else {
          Vue.set(state.locations, index, user);
        }
      });
    }
  },
  actions: {
    async getLocationsForCompany({ state, commit }, guid) {
      if (state.locations.some((s) => s.companyGuid === guid)) {
        //check if already have features
        return state.locations.filter((s) => s.companyGuid === guid);
      }
      try {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.get(`/locations?company_guid=${guid}`);
        const locations = data.map((d) => ({ ...d, companyGuid: guid }));
        commit('ADD_LOCATIONS', locations);
        return locations;
      } catch (e) {
        throw e;
      }
    },
    async addLocationToCompany({ _commit }, { guid, name }) {
      try {
        const {
          data: { data }
        } = await APIHelper.AdminAPI.put('/locations', {
          company_guid: guid,
          name: name
        });
        const location = data;
        location.companyGuid = guid;
        commit('ADD_LOCATIONS', [location]);
      } catch (e) {
        throw e;
      }
    }
  }
};
